export const BackofficePermissionsEnum = {
  // ----- CLIENTES -----
  USER_CUSTOMER: {
    LIST: 'user_customer_list',
    SHOW: 'user_customer_show',
    IMPORT: 'user_customer_import',
    EXPORT: 'user_customer_export',
    UNLOCK: 'user_customer_unlock',
    UNLOCK_FACEPHI: 'user_customer_unlock_facephi',
    DELETE: 'user_customer_delete',
  },

  // ----- FONDOS ------
  FUND: {
    LIST: 'fund_list',
    SYNC: 'fund_sync',
    UPDATE: 'fund_update', // configuracion
    CHANGE_STATUS: 'fund_change_status',
    RECOMMENDED: 'fund_recommend',
  },

  RECOMMENDED_CONFIG: {
    SHOW: 'fund_recommended_config_show',
    DOCUMENT_SHOW: 'fund_recommended_config_document_show',
    DOCUMENT_UPLOAD: 'fund_recommended_config_document_upload',
    SAVE: 'fund_recommended_config_save',
    PUBLISH: 'fund_recommended_config_publish',
  },

  // Tabs de fondo
  FUND_TABS: {
    // Tab Info y Riesgo
    INFO: {
      SHOW: 'fund_info_show',
      IMAGE_UPLOAD: 'fund_info_image_upload',
      SAVE: 'fund_info_save',
      PUBLISH: 'fund_info_publish',
    },

    // Tab Estrategia de inversión
    STRATEGY: {
      GRAPHIC_EDIT: 'fund_strategy_graphic_edit',
      SAVE: 'fund_strategy_save',
      PUBLISH: 'fund_strategy_publish',
    },

    // Tab Rendimiento
    PERFORMANCE: {
      RECORD_EDIT: 'fund_performance_record_edit',
      SAVE: 'fund_performance_save',
      PUBLISH: 'fund_performance_publish',
    },

    // Tab Contenido
    CONTENT: {
      CHANNEL_EDIT: 'fund_content_channel_edit',
      FEATURES_EDIT: 'fund_content_features_edit',
      COMMISSIONS_EDIT: 'fund_content_commissions_edit',
      DISCLAIMER_EDIT: 'fund_content_disclaimer_edit',
      LEGAL_EDIT: 'fund_content_legal_edit',
      DOCUMENT_SHOW: 'fund_content_document_show',
      DOCUMENT_UPLOAD: 'fund_content_document_upload',
      SAVE: 'fund_content_save',
      PUBLISH: 'fund_content_publish',
    },

    // Tab Portafolio
    PORTFOLIO: {
      GRAPHIC_EDIT: 'fund_portfolio_graphic_edit',
      SAVE: 'fund_portfolio_save',
      PUBLISH: 'fund_portfolio_publish',
    },

    // Tab Valor cuota
    QUOTE_VALUE: {
      YAXIS_EDIT: 'fund_quote_value_yaxis_edit',
      EVOLUTION_EDIT: 'fund_quote_value_evolution_edit',
      SHOW: 'fund_quote_value_show',
      SAVE: 'fund_quote_value_save',
      PUBLISH: 'fund_quote_value_publish',
    },
  },

  // ----- MOVIMIENTOS -----
  MOVIMIENTOS_ALL: [] as string[],
  // Solicitudes pendientes
  REQUEST_PENDING: {
    LIST: 'request_pending_list',
    UPDATE: 'request_pending_update',
    CANCEL: 'request_pending_cancel',
    SPECTRUM: 'request_pending_spectrum',
    SHOW: 'request_pending_show',
    EXPORT: 'request_pending_export',
  },

  // Suscripciones
  SUBSCRIPTION: {
    LIST: 'subscription_list',
    EXPORT : 'subscription_export',
    SHOW: 'subscription_show', // FIXED: no tiene detalle - Preguntar -> Amarrar al número de operación y adjuntos
    CREATE_MANUAL: 'subscription_create_manual',
  },

  // Solicitudes anuladas
  REQUEST_CANCELED: {
    LIST: 'request_canceled_list',
    SHOW: 'request_canceled_show', 
    EXPORT: 'request_canceled_export', // no tiene detalle - Preguntar
  },

  // Rescates
  RESCUE: {
    LIST: 'rescue_list',
    CHANGE_STATUS: 'rescue_change_status',
  },

  // Rescates pendientes
  RESCUE_PENDING: {
    LIST: 'rescue_pending_list',
    SHOW: 'rescue_pending_show',
    SPECTRUM: 'rescue_pending_spectrum',
    CANCEL: 'rescue_pending_cancel',
    EXPORT: 'rescue_pending_export',
  },

  // Rescates anulados
  RESCUE_CANCELED: {
    LIST: 'rescue_canceled_list',
    SHOW: 'rescue_canceled_show',
    EXPORT: 'rescue_canceled_export',
  },

  // Validación de Cuenta
  ACCOUNT_VALIDATED: {
    LIST: 'account_validated_list',
    CANCEL: 'account_validated_cancel',
    EXPORT: 'account_validated_export',
    APPROVE: 'account_validated_approve',
  },

  // ----- CONFIGURACION -----
  CONFIG_ALL: [] as string[],
  // Usuarios
  USER_PERSON: {
    LIST: 'user_person_list',
    SHOW: 'user_person_show',
    CREATE: 'user_person_create',
    UPDATE: 'user_person_update',
    DELETE: 'user_person_delete', // no hay delete, preguntar
  },

  // Roles y permisos
  ROLE: {
    LIST: 'capability_role_list',
    SHOW: 'capability_role_show',
    CREATE: 'capability_role_create',
    UPDATE: 'capability_role_update',
    DELETE: 'capability_role_delete', // no hay delete, preguntar
  },

  // prospectos
  USER_PROSPECT: {
    LIST: 'user_prospect_list',
    SHOW: 'user_prospect_show', // preguntar no hay opción de detalle
    UPDATE: 'user_prospect_update', // hay una opción más de Generar contraseña, preguntar si se va a separar con otro permiso
  },

  // Tolerancia al riesgo
  RISK_TOLERANCE: {
    LIST: 'risk_tolerance_list', // NEW
    UPDATE: 'risk_tolerance_update', // FIXED: solo existe 1, se debería tener 2? uno para ver y otro para el botón Editar
  },

  // Lista asesoras
  USER_EXECUTIVE: {
    LIST: 'user_executive_list',
    SHOW: 'user_executive_show',
    SYNC: 'user_executive_sync',
    UPDATE: 'user_executive_update',
    ARCHIVE: 'user_executive_archive',
  },

  // Configuracion general
  GENERAL_CONFIG: {
    UPDATE: 'general_config_update', // falta consultar
    UPDATE_BANNER : 'general_config_update_banner',
  },

  // Audit
  AUDIT: {
    LIST: 'audit_list',
    SHOW: 'audit_show',
    EXPORT: 'audit_export',
  },

  // ----- LOGS -----
  LOGGER: {
    LIST: 'logger_list',
  },
}

BackofficePermissionsEnum.MOVIMIENTOS_ALL = [
  ...Object.values(BackofficePermissionsEnum.REQUEST_PENDING),
  ...Object.values(BackofficePermissionsEnum.SUBSCRIPTION),
  ...Object.values(BackofficePermissionsEnum.REQUEST_CANCELED),
  ...Object.values(BackofficePermissionsEnum.RESCUE),
  ...Object.values(BackofficePermissionsEnum.RESCUE_PENDING),
  ...Object.values(BackofficePermissionsEnum.RESCUE_CANCELED),
  ...Object.values(BackofficePermissionsEnum.ACCOUNT_VALIDATED),
]

BackofficePermissionsEnum.CONFIG_ALL = [
  ...Object.values(BackofficePermissionsEnum.USER_PERSON),
  ...Object.values(BackofficePermissionsEnum.ROLE),
  ...Object.values(BackofficePermissionsEnum.USER_PROSPECT),
  ...Object.values(BackofficePermissionsEnum.RISK_TOLERANCE),
  ...Object.values(BackofficePermissionsEnum.USER_EXECUTIVE),
  ...Object.values(BackofficePermissionsEnum.GENERAL_CONFIG),
  ...Object.values(BackofficePermissionsEnum.AUDIT),
]
